class VwHbsHastataniDTO {
    id: number = null;
    tanitanimId?: string = "";
    kimlikId?: number = null;
    muracaatId?: number = null;
    hastaservisId?: number = null;
    servisId?: number = null;
    doktorId?: number = null;
    tarih?: string = null;
    tanitipId?: number = null;
    aciklama?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptal?: string = "H";
    iptalTarihi?: string = null;
    iptalKullanici?: number = null;
    kodu?: string = "";
    adi?: string = "";
    doktorAdi?: string = "";
    servisAdi?: string = "";
}
export default VwHbsHastataniDTO;